import { useEffect } from 'react';

import { isTextInputElement } from './dom';

interface UseKeyboardShortcutsParams {
  canProceed: boolean;
  isOnIntro: boolean;
  isComplete: boolean;
  onNext: () => void | Promise<void>;
  onBack: () => void;
}

export function useKeyboardShortcuts({
  canProceed,
  isOnIntro,
  isComplete,
  onNext,
  onBack,
}: UseKeyboardShortcutsParams) {
  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.isComposing) {
        return;
      }

      if (isOnIntro || isComplete) {
        return;
      }

      if (event.key === 'Enter' && !event.shiftKey) {
        if (isTextInputElement(event.target as Element)) {
          return;
        }

        if (canProceed) {
          event.preventDefault();
          void onNext();
        }
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        onBack();
      }
    };

    window.addEventListener('keydown', listener);
    return () => window.removeEventListener('keydown', listener);
  }, [canProceed, isComplete, isOnIntro, onBack, onNext]);
}

